import {observable, action, runInAction, computed} from 'mobx'
import {get} from '../../../../utils/ajax'

class ToolContentStore {
    @observable content;
    @observable tableList;
    @observable loading;

    constructor() {
        this.loading = false;
        this.tableList = {};
        this.toolContent = [];
    }

    /***文本显示数据****/
    @action
    initPage = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/componentsContent/reception/searchOne?componentsId=${id}`)
        const ress = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/components/id/${id}`)
        runInAction(() => {
            this.toolContent = res || [];
            this.tableList = ress || [];
            this.loading = false;
        })
    }


}

export default new ToolContentStore()


// WEBPACK FOOTER //
// ./src/project/dongfeng/toolkit/ToolContent/store.js